// extracted by mini-css-extract-plugin
export default {"heading":"hu-z","signin":"iu-z","signupBtn":"ju-z","disabled":"ku-z"};